import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-catalog-page-card',
  imports: [RouterLink],
  templateUrl: './catalog-page-card.html',
})
export class CatalogPageCardComponent {
  @Input({ required: true })
  title = '';

  @Input()
  containerClass = '';

  @Input()
  wide = false;
}
